// Thin wrapper around the browser-native Web Speech API (window.speechSynthesis) — no TTS API
// key, no per-request cost. Shared between the dyslexia-mode "read aloud" button and the
// Subject Explorer "story mode" guided tour.

export function isNarrationSupported() {
  return typeof window !== 'undefined' && 'speechSynthesis' in window;
}

export function speak(text, { onEnd } = {}) {
  if (!isNarrationSupported() || !text) {
    return false;
  }

  window.speechSynthesis.cancel();
  const utterance = new SpeechSynthesisUtterance(String(text));
  utterance.rate = 0.95;
  if (onEnd) {
    utterance.onend = onEnd;
  }
  window.speechSynthesis.speak(utterance);
  return true;
}

export function stopNarration() {
  if (isNarrationSupported()) {
    window.speechSynthesis.cancel();
  }
}

export function pauseNarration() {
  if (isNarrationSupported()) {
    window.speechSynthesis.pause();
  }
}

export function resumeNarration() {
  if (isNarrationSupported()) {
    window.speechSynthesis.resume();
  }
}

export function isNarrating() {
  return isNarrationSupported() && window.speechSynthesis.speaking;
}
